// extracted by mini-css-extract-plugin
module.exports = {"note":"accountForm_note__2Z8xA"};